import { render, staticRenderFns } from "./MISSuggestions.vue?vue&type=template&id=4de759e2"
import script from "./MISSuggestions.vue?vue&type=script&lang=js"
export * from "./MISSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports